export default __webpack_public_path__ + "static/media/luggage.644f951c.png";